import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexPage from '../views/index.vue'
import HomeView from '../views/Home/index.vue'
import ServiceView from '../views/Service/index.vue'
import ActuateView from '../views/Actuate/index'
import AboutView from '../views/About/index'
import ArticleDetailView from '../views/About/components/ArticleDetail/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexPage,
    redirect: { name: 'home' },

    children: [
      {
        name: 'home',
        path: 'home',
        component: HomeView
      }, {
        name: 'service',
        path: 'service',
        component: ServiceView
      }, {
        name: 'actuate',
        path: 'actuate',
        component: ActuateView
      }, {
        name: 'about',
        path: 'about/:item',
        component: AboutView,
        children: [
          {
            name: 'announceDetail',
            path: 'announceDetail/:announceId',
            props: true,
            component: ArticleDetailView

          },
          {
            name: 'newsDetail',
            path: 'newsDetail/:newsId',
            props: true,
            component: ArticleDetailView

          }
        ]

      }
    ]

  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
